import { Check, Search } from 'lucide-react'
import { useState } from 'react'

import { ImageContainer } from '@/components'
import { IconActionButton } from '@/components/common/buttons/icon-action-button'
import { ExpandableSheetContent } from '@/components/common/layout/expandable-sheet-content'
import {
  Sheet,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { VistaProductHooks } from '@/features/equipamentos/hooks/use-vista-produtos'
import {
  EquipmentVistaProduct,
  Product,
} from '@/services/backend/config/entities'

interface ExtendedEquipmentVistaProduct extends EquipmentVistaProduct {
  Product: Product
}

interface Props {
  vistaId: string
  onSelect: (data: ExtendedEquipmentVistaProduct) => void
}

export default function Component({ vistaId, onSelect }: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const {
    query: { data },
  } = VistaProductHooks.getByVistaId(vistaId)

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <IconActionButton icon={Search} tooltip="Selecionar" />
      </SheetTrigger>

      <ExpandableSheetContent>
        <SheetHeader>
          <SheetTitle>Selecione um produto</SheetTitle>
          <div className="flex flex-col items-center gap-2">
            <ImageContainer src={data?.vista.imageStr ?? undefined} className="size-16" />
            <p className="text-center text-sm font-normal">
              {data?.vista.name}
            </p>
          </div>
        </SheetHeader>

        <div className="mt-4">
          {data?.products.map((ea) => {
            return (
              <div
                key={ea.id}
                className="mb-8 grid grid-cols-[auto,1fr,auto] items-center gap-4"
              >
                <div className="flex h-8 min-w-8 items-center justify-center rounded-md border">
                  <p className="text-sm font-bold">{ea.vistaIndex + 1}</p>
                </div>

                <div className="grid overflow-hidden">
                  <p className="text-xs font-bold">{ea.Product.sku}</p>
                  <p className="overflow-hidden text-ellipsis whitespace-nowrap">
                    {ea.Product.name}
                  </p>
                </div>

                <IconActionButton
                  icon={Check}
                  tooltip="Selecionar"
                  onClick={() => onSelect(ea)}
                />
              </div>
            )
          })}
        </div>
      </ExpandableSheetContent>
    </Sheet>
  )
}
